
import BlackVanIcon from '@/static/svg/prescription/black-van-icon.svg'
import FadingTransition from '@/components/FadingTransition'

export default {
  components: {
    BlackVanIcon,
    FadingTransition,
  },
  props: {
    freeShippingAt: {
      type: [String, Number],
      default: '',
    },
    orderPrice: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      shippingThreshold: 0,
      shippingThresholdTimeout: null,
      shippingThresholdDelay: null,
    }
  },
  computed: {
    shipping() {
      return parseFloat(this.freeShippingAt).toFixed(2) - parseFloat(this.orderPrice).toFixed(2)
    },
  },
  watch: {
    orderPrice() {
      clearTimeout(this.shippingThresholdTimeout)
      if (+parseFloat(this.orderPrice).toFixed(2) > +parseFloat(this.freeShippingAt).toFixed(2)) {
        return
      }
      this.shippingThresholdTimeout = setTimeout(() => this.updateShippingThreshold(), 550)
    },
    shipping() {
      this.shippingThreshold = this.shipping
    },
  },
  mounted() {
    this.shippingThreshold = this.shipping
  },
  methods: {
    updateShippingThreshold() {
      if (this.shippingThreshold <= this.shipping)
        for (let i = this.shippingThreshold; i <= this.shipping; i += 0.01) {
          this.increasePrice(i)
        }

      if (this.shippingThreshold >= this.shipping)
        for (let i = this.shippingThreshold; i >= this.shipping; i -= 0.01) {
          this.decreasePrice(i)
        }

      clearTimeout(this.shippingThresholdDelay)
      this.shippingThresholdDelay = setTimeout(
        () => {
          this.shippingThreshold = this.shipping
        },
        this.shipping * 20 + 550,
      )
    },
    increasePrice(timeout) {
      setTimeout(() => {
        this.shippingThreshold += 0.01
      }, 20 * timeout)
    },
    decreasePrice(timeout) {
      setTimeout(() => {
        this.shippingThreshold -= 0.01
      }, 20 * timeout)
    },
  },
}
